import { Bank } from "./Bank";
import { Calendar } from "./Calendar";
import { Cancel } from "./Cancel";
import { CancelAlt } from "./CancelAlt";
import { Check } from "./Check";
import { MonthlyDeposit } from "./MonthlyDeposit";
import { Deposit } from "./Deposit";
import { Earth } from "./Earth";
import { Edit } from "./Edit";
import { Eye } from "./Eye";
import { Home } from "./Home";
import { Invite } from "./Invite";
import { Message } from "./Message";
import { More } from "./More";
import { Plus } from "./Plus";
import { PlusAlt } from "./PlusAlt";
import { Profile } from "./Profile";
import { SavingsAccount } from "./SavingsAccount";
import { Search } from "./Search";
import { Sustainable } from "./Sustainable";
import { Transfer } from "./Transfer";
import { Withdraw } from "./Withdraw";
import { Lock } from "./Lock";
import { LockOpen } from "./LockOpen";
import { Shopping } from "./Shopping";
import { Copy } from "./Copy";
import { Menu } from "./Menu";
import { Portfolio } from "./Portfolio";
import { Settings } from "./Settings";
import { Tune } from "./Tune";
import { Goal } from "./Goal";
import { DoughnutGraph } from "./DoughnutGraph";
import { Delete } from "./Delete";
import { Heart } from "./Heart";
import { Print } from "./Print";
import { Minus } from "./Minus";
import { MinusAlt } from "./MinusAlt";
import { Globe } from "./Globe";
import { Download } from "./Download";
import { ExternalLink } from "./ExternalLink";
import { ShareAndroid } from "./ShareAndroid";
import { ShareiOS } from "./ShareiOS";
import { Gift } from "./Gift";
import { Rocket } from "./Rocket";
import { Retry } from "./Retry";
import { Document } from "./Document";
import { Logout } from "./Logout";
import { Investment } from "./Investment";
import { Attachment } from "./Attachment";
import { ProfileAlt } from "./ProfileAlt";
import { Accounts } from "./Accounts";
import { ChevronLeft } from "./ChevronLeft";
import { ChevronRight } from "./ChevronRight";
import { ChevronDown } from "./ChevronDown";
import { ChevronUp } from "./ChevronUp";
import { Up } from "./Up";
import { Down } from "./Down";
import { Back } from "./Back";
import { Forward } from "./Forward";
import { Bell } from "./Bell";
import { BellNotification } from "./BellNotification";
import { Information } from "./Information";
import { Help } from "./Help";
import { Alert } from "./Alert";
import { New } from "./New";
import { Warning } from "./Warning";
import { Energy } from "./Energy";
import { Materials } from "./Materials";
import { Industrials } from "./Industrials";
import { ConsumerDiscretionary } from "./ConsumerDiscretionary";
import { ConsumerStaples } from "./ConsumerStaples";
import { HealthCare } from "./HealthCare";
import { InformationTechnology } from "./InformationTechnology";
import { Decrease } from "./Decrease";
import { Increase } from "./Increase";
import { Phone } from "./Phone";
import { Clock } from "./Clock";
import { ShareWindows } from "./ShareWindows";
import { AlertOutline } from "./AlertOutline";
import { Chat } from "./Chat";
import { CommunicationServices } from "./CommunicationServices";
import { Signature } from "./Signature";
import { Success } from "./Success";
import { SuccessOutline } from "./SuccessOutline";
import { Utilities } from "./Utilities";
import { WarningOutline } from "./WarningOutline";
import { RealEstate } from "./RealEstate";
import { Move } from "./Move";
import { NewOutline } from "./NewOutline";
import { InformationOutline } from "./InformationOutline";
import { HelpOutline } from "./HelpOutline";
import { Global } from "./Global";
import { BankId } from "./BankId";
import { Facebook } from "./Facebook";
import { Instagram } from "./Instagram";
import { LinkedIn } from "./LinkedIn";
import { Twitter } from "./Twitter";
import { Recieve } from "./Recieve";
import { InviteFriend } from "./InviteFriend";
import { PersonalSecurity } from "./PersonalSecurity";
export const DEFAULT_ICON_SIZE = 24;
export const DEFAULT_ICON_PRIMARY_COLOR = "var(--lysa-icon-primary)";
export const DEFAULT_ICON_SECONDARY_COLOR = "transparent";
export const Icon = {
    Accounts,
    Alert,
    AlertOutline,
    Attachment,
    Back,
    Bank,
    BankId,
    Bell,
    BellNotification,
    Calendar,
    Cancel,
    CancelAlt,
    Chat,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Clock,
    CommunicationServices,
    ConsumerDiscretionary,
    ConsumerStaples,
    Copy,
    Decrease,
    Delete,
    MonthlyDeposit,
    Deposit,
    Document,
    DoughnutGraph,
    Down,
    Download,
    Earth,
    Edit,
    Energy,
    ExternalLink,
    Eye,
    Facebook,
    Forward,
    Gift,
    Global,
    Globe,
    Goal,
    HealthCare,
    Heart,
    Help,
    HelpOutline,
    Home,
    Increase,
    Industrials,
    Information,
    InformationOutline,
    InformationTechnology,
    Instagram,
    Investment,
    Invite,
    LinkedIn,
    Lock,
    LockOpen,
    Logout,
    Materials,
    Menu,
    Message,
    Minus,
    MinusAlt,
    More,
    Move,
    New,
    NewOutline,
    PersonalSecurity,
    Phone,
    Plus,
    PlusAlt,
    Portfolio,
    Print,
    Profile,
    ProfileAlt,
    RealEstate,
    Rocket,
    Retry,
    SavingsAccount,
    Search,
    Settings,
    ShareAndroid,
    ShareiOS,
    ShareWindows,
    Shopping,
    Signature,
    Success,
    SuccessOutline,
    Sustainable,
    Transfer,
    Tune,
    Twitter,
    Up,
    Utilities,
    Warning,
    WarningOutline,
    Withdraw,
    Recieve,
    InviteFriend,
};
